var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 26,
    viewBox: "0 0 25 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Plus",
    clipPath: "url(#clip0_5699_2276)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M21.605 10.1501H15.285V3.83007C15.285 2.27757 13.98 1.00757 12.4275 1.00757C10.875 1.00757 9.56999 2.27757 9.56999 3.83007V10.1501H3.24999C1.69749 10.1501 0.42749 11.4551 0.42749 13.0076C0.42749 14.5601 1.69749 15.8651 3.24999 15.8651H9.56999V22.1851C9.56999 23.7376 10.875 25.0076 12.4275 25.0076C13.98 25.0076 15.285 23.7376 15.285 22.1851V15.8651H21.605C23.1575 15.8651 24.4275 14.5601 24.4275 13.0076C24.4275 11.4551 23.1575 10.1501 21.605 10.1501Z",
    fill: "#0C71C3"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5699_2276"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 25,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlus);
export default __webpack_public_path__ + "static/media/Plus.1891acf5c70e87c197e23d26f8db81b9.svg";
export { ForwardRef as ReactComponent };